import { useLocation } from "react-router-dom";
import useApis from "../../services/useAPI";
import { Row, Button, Container } from "react-bootstrap";

const Registration = () => {
  const location = useLocation();

  const { callApi } =
    useApis() || {};

  return (
    <div className="nhs-registration-section">
      <h1 className="mb-0">Link your test results</h1>
      <div className="container-fluid mt-3 p-0">
        <h3 className="text-mhc-berry ageo-regular fs-28">See your test results on the NHS app</h3>
        <p className="fs-20 registration-title">
          We’ve partnered with <strong>Patients Know Best</strong>, the UK’s leading personal health record platform, to offer you this <strong>free</strong> feature.
        </p>
        <hr />

        <h4 className="fs-22 text-teal ageo-semibold mb-0"> It's a simple 2 step process</h4>

        <Container className="px-0">
          <Row className="custom-card m-0 w-100 flex-wrap">
            <div className="col-md-12 p-0">
              <div className="border-0 fs-18 d-flex flex-column align-items-start">
                <div className="step-item">
                  <div className="step-pill">STEP 1</div>
                  <div className="new-step-line" />
                </div>
                <p className="mb-1">Register for this service using your NHS App login. It takes just 2 minutes.</p>
              </div>
            </div>

            <div className="col-md-12 my-3 p-0">
              <div className="border-0 text-muted">
                <Button
                  onClick={() => {
                    if (!location.state?.registration_began) {
                      callApi(
                        {
                          user_id: JSON.parse(localStorage.getItem("user_id")),
                          registration_began_at: new Date(),
                        },
                        "/api/dashboard/pkb-save-consent-time/",
                        "POST",
                        true
                      );
                    }
                    window.open("https://patientsknowbest.com/register/", "_blank", "noopener,noreferrer");
                  }}
                >
                  Register
                </Button>

              </div>
            </div>
            <div className="col-md-12 p-0">
              <div className="border-0">
                <p className="fs-18">
                 Linking your results will allow you to view them in your NHS App alongside your other NHS health data, in participating regions. This includes your historical results and any future results through a simple one-time registration.
                </p>
              </div>
            </div>
            <div className="col-md-12 p-0">
              <div className="border-0 fs-18 d-flex flex-column align-items-start">
                <div className="step-item">
                  <div className="step-pill">STEP 2</div>
                  <div className="new-step-line" />
                </div>
                <p> Once registered, return to your dashboard to link your accounts and complete the process.</p>
              </div>
            </div>
          </Row>


        </Container>
        </div>
      </div>
  );
};

export default Registration;